import type { CheckboxProps as HeroCheckboxProps } from '@heroui/react'
import { Checkbox as HeroCheckbox } from '@heroui/react'
import { motion } from 'framer-motion'
import type { ReactNode } from 'react'

export interface CheckboxProps
  extends Omit<HeroCheckboxProps, 'onChange' | 'isSelected' | 'value'> {
  label: string | ReactNode
  classNameContainer?: string
  name?: string
  value?: boolean
  onChange?: (checked: boolean) => void
  onBlur?: () => void
  errorMessage?: string
}

const Checkbox = ({
  label,
  classNameContainer,
  name,
  value = false,
  onChange,
  onBlur,
  errorMessage,
  ...props
}: CheckboxProps) => {
  return (
    <motion.div className={classNameContainer}>
      <HeroCheckbox
        errorMessage={errorMessage}
        isInvalid={Boolean(errorMessage)}
        isSelected={value}
        name={name}
        onBlur={onBlur}
        onValueChange={onChange}
        {...props}
      >
        {label}
      </HeroCheckbox>
    </motion.div>
  )
}

export default Checkbox
